import { useCallback, useContext, useMemo } from 'react';

import { RxFormApi } from '../types';
import { RxFormContext } from '../Context';
import { createDebug } from '../utils/debug';

const debug = createDebug('useFormApi');

/**
 *
 */
export function useFormApi(): RxFormApi {
    const ctx = useContext(RxFormContext);
    const setValue = useCallback(
        (field: string, value: any) => {
            debug('setValue()', field, value);
            const valueToSet = value === undefined || value === null ? '' : value;
            debug('setValue() corrected', field, value);
            ctx.next &&
                ctx.next({
                    type: 'set-field-value',
                    field,
                    value: valueToSet,
                });
        },
        [ctx],
    );
    const setValues = useCallback(
        (obj: { [index: string]: any }) => {
            debug('setValues()', obj);
            Object.keys(obj).forEach((key) => {
                setValue(key, obj[key]);
            });
        },
        [setValue],
    );
    const getValue = useCallback(
        (field: string) => {
            debug('getValue()', field);
            return ctx.getValue(field);
        },
        [ctx],
    );
    return useMemo(() => {
        return { setValue, setValues, getValue };
    }, [getValue, setValue, setValues]);
}
